import { BaseRequest } from '@trukt/types/BaseRequest';
import { AxiosInstance } from 'axios';

type LineRequestQueryParams = Partial<{ force?: boolean }>;

export type LineCreateRequest = Pick<
  BaseRequest<
    LineRequestQueryParams,
    { amount?: string; itemId: string; notes?: string },
    { invoiceGuid: string }
  >,
  'queryParams' | 'body' | 'routeParams'
>;
export type LineCreateResponse = { guid: string };

export type LineDeleteRequest = Pick<
  BaseRequest<LineRequestQueryParams, void, { invoiceGuid: string; lineGuid: string }>,
  'queryParams' | 'routeParams'
>;
export type LineDeleteResponse = void;

export type LineUpdateRequest = Pick<
  BaseRequest<
    LineRequestQueryParams,
    { amount?: string | null; itemId: string; notes?: string | null },
    { invoiceGuid: string; lineGuid: string }
  >,
  'queryParams' | 'body' | 'routeParams'
>;
export type LineUpdateResponse = void;

export class LineService {
  instance: AxiosInstance;
  constructor(instance: AxiosInstance) {
    this.instance = instance;
  }

  create(request: LineCreateRequest) {
    return this.instance.post<LineCreateResponse>(
      `invoices/${request.routeParams.invoiceGuid}/lines`,
      request.body,
      { params: request.queryParams },
    );
  }

  delete(request: LineDeleteRequest) {
    return this.instance.delete<LineDeleteResponse>(
      `invoices/${request.routeParams.invoiceGuid}/lines/${request.routeParams.lineGuid}`,
      { params: request.queryParams },
    );
  }

  update(request: LineUpdateRequest) {
    return this.instance.patch<LineUpdateResponse>(
      `invoices/${request.routeParams.invoiceGuid}/lines/${request.routeParams.lineGuid}`,
      request.body,
      { params: request.queryParams },
    );
  }
}
